// source: nockchain/common/v2/blockchain.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var nockchain_common_v1_blockchain_pb = require('../../../nockchain/common/v1/blockchain_pb.js');
goog.object.extend(proto, nockchain_common_v1_blockchain_pb);
var nockchain_common_v1_pagination_pb = require('../../../nockchain/common/v1/pagination_pb.js');
goog.object.extend(proto, nockchain_common_v1_pagination_pb);
var nockchain_common_v1_primitives_pb = require('../../../nockchain/common/v1/primitives_pb.js');
goog.object.extend(proto, nockchain_common_v1_primitives_pb);
goog.exportSymbol('proto.nockchain.common.v2.Balance', null, global);
goog.exportSymbol('proto.nockchain.common.v2.BalanceEntry', null, global);
goog.exportSymbol('proto.nockchain.common.v2.BurnLock', null, global);
goog.exportSymbol('proto.nockchain.common.v2.HaxLock', null, global);
goog.exportSymbol('proto.nockchain.common.v2.HaxPreimage', null, global);
goog.exportSymbol('proto.nockchain.common.v2.LegacySpend', null, global);
goog.exportSymbol('proto.nockchain.common.v2.LockMerkleProof', null, global);
goog.exportSymbol('proto.nockchain.common.v2.LockPrimitive', null, global);
goog.exportSymbol('proto.nockchain.common.v2.LockPrimitive.PrimitiveCase', null, global);
goog.exportSymbol('proto.nockchain.common.v2.LockTim', null, global);
goog.exportSymbol('proto.nockchain.common.v2.MerkleProof', null, global);
goog.exportSymbol('proto.nockchain.common.v2.Note', null, global);
goog.exportSymbol('proto.nockchain.common.v2.Note.NoteVersionCase', null, global);
goog.exportSymbol('proto.nockchain.common.v2.NoteData', null, global);
goog.exportSymbol('proto.nockchain.common.v2.NoteDataEntry', null, global);
goog.exportSymbol('proto.nockchain.common.v2.NoteV1', null, global);
goog.exportSymbol('proto.nockchain.common.v2.PkhLock', null, global);
goog.exportSymbol('proto.nockchain.common.v2.PkhSignature', null, global);
goog.exportSymbol('proto.nockchain.common.v2.PkhSignatureEntry', null, global);
goog.exportSymbol('proto.nockchain.common.v2.RawTransaction', null, global);
goog.exportSymbol('proto.nockchain.common.v2.Seed', null, global);
goog.exportSymbol('proto.nockchain.common.v2.Spend', null, global);
goog.exportSymbol('proto.nockchain.common.v2.Spend.SpendKindCase', null, global);
goog.exportSymbol('proto.nockchain.common.v2.SpendCondition', null, global);
goog.exportSymbol('proto.nockchain.common.v2.SpendEntry', null, global);
goog.exportSymbol('proto.nockchain.common.v2.Witness', null, global);
goog.exportSymbol('proto.nockchain.common.v2.WitnessSpend', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.Balance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.common.v2.Balance.repeatedFields_, null);
};
goog.inherits(proto.nockchain.common.v2.Balance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.Balance.displayName = 'proto.nockchain.common.v2.Balance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.BalanceEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v2.BalanceEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.BalanceEntry.displayName = 'proto.nockchain.common.v2.BalanceEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.Note = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.nockchain.common.v2.Note.oneofGroups_);
};
goog.inherits(proto.nockchain.common.v2.Note, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.Note.displayName = 'proto.nockchain.common.v2.Note';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.NoteV1 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v2.NoteV1, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.NoteV1.displayName = 'proto.nockchain.common.v2.NoteV1';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.NoteData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.common.v2.NoteData.repeatedFields_, null);
};
goog.inherits(proto.nockchain.common.v2.NoteData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.NoteData.displayName = 'proto.nockchain.common.v2.NoteData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.NoteDataEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v2.NoteDataEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.NoteDataEntry.displayName = 'proto.nockchain.common.v2.NoteDataEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.RawTransaction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.common.v2.RawTransaction.repeatedFields_, null);
};
goog.inherits(proto.nockchain.common.v2.RawTransaction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.RawTransaction.displayName = 'proto.nockchain.common.v2.RawTransaction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.SpendEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v2.SpendEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.SpendEntry.displayName = 'proto.nockchain.common.v2.SpendEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.Spend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.nockchain.common.v2.Spend.oneofGroups_);
};
goog.inherits(proto.nockchain.common.v2.Spend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.Spend.displayName = 'proto.nockchain.common.v2.Spend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.LegacySpend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.common.v2.LegacySpend.repeatedFields_, null);
};
goog.inherits(proto.nockchain.common.v2.LegacySpend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.LegacySpend.displayName = 'proto.nockchain.common.v2.LegacySpend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.WitnessSpend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.common.v2.WitnessSpend.repeatedFields_, null);
};
goog.inherits(proto.nockchain.common.v2.WitnessSpend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.WitnessSpend.displayName = 'proto.nockchain.common.v2.WitnessSpend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.Seed = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v2.Seed, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.Seed.displayName = 'proto.nockchain.common.v2.Seed';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.Witness = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.common.v2.Witness.repeatedFields_, null);
};
goog.inherits(proto.nockchain.common.v2.Witness, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.Witness.displayName = 'proto.nockchain.common.v2.Witness';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.HaxPreimage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v2.HaxPreimage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.HaxPreimage.displayName = 'proto.nockchain.common.v2.HaxPreimage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.PkhSignature = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.common.v2.PkhSignature.repeatedFields_, null);
};
goog.inherits(proto.nockchain.common.v2.PkhSignature, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.PkhSignature.displayName = 'proto.nockchain.common.v2.PkhSignature';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.PkhSignatureEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v2.PkhSignatureEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.PkhSignatureEntry.displayName = 'proto.nockchain.common.v2.PkhSignatureEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.LockMerkleProof = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v2.LockMerkleProof, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.LockMerkleProof.displayName = 'proto.nockchain.common.v2.LockMerkleProof';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.SpendCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.common.v2.SpendCondition.repeatedFields_, null);
};
goog.inherits(proto.nockchain.common.v2.SpendCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.SpendCondition.displayName = 'proto.nockchain.common.v2.SpendCondition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.LockPrimitive = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.nockchain.common.v2.LockPrimitive.oneofGroups_);
};
goog.inherits(proto.nockchain.common.v2.LockPrimitive, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.LockPrimitive.displayName = 'proto.nockchain.common.v2.LockPrimitive';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.PkhLock = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.common.v2.PkhLock.repeatedFields_, null);
};
goog.inherits(proto.nockchain.common.v2.PkhLock, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.PkhLock.displayName = 'proto.nockchain.common.v2.PkhLock';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.LockTim = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v2.LockTim, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.LockTim.displayName = 'proto.nockchain.common.v2.LockTim';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.HaxLock = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.common.v2.HaxLock.repeatedFields_, null);
};
goog.inherits(proto.nockchain.common.v2.HaxLock, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.HaxLock.displayName = 'proto.nockchain.common.v2.HaxLock';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.BurnLock = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v2.BurnLock, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.BurnLock.displayName = 'proto.nockchain.common.v2.BurnLock';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v2.MerkleProof = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.common.v2.MerkleProof.repeatedFields_, null);
};
goog.inherits(proto.nockchain.common.v2.MerkleProof, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v2.MerkleProof.displayName = 'proto.nockchain.common.v2.MerkleProof';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.common.v2.Balance.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.Balance.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.Balance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.Balance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.Balance.toObject = function(includeInstance, msg) {
  var f, obj = {
notesList: jspb.Message.toObjectList(msg.getNotesList(),
    proto.nockchain.common.v2.BalanceEntry.toObject, includeInstance),
height: (f = msg.getHeight()) && nockchain_common_v1_primitives_pb.BlockHeight.toObject(includeInstance, f),
blockId: (f = msg.getBlockId()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f),
page: (f = msg.getPage()) && nockchain_common_v1_pagination_pb.PageResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.Balance}
 */
proto.nockchain.common.v2.Balance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.Balance;
  return proto.nockchain.common.v2.Balance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.Balance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.Balance}
 */
proto.nockchain.common.v2.Balance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v2.BalanceEntry;
      reader.readMessage(value,proto.nockchain.common.v2.BalanceEntry.deserializeBinaryFromReader);
      msg.addNotes(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.BlockHeight;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.BlockHeight.deserializeBinaryFromReader);
      msg.setHeight(value);
      break;
    case 3:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setBlockId(value);
      break;
    case 4:
      var value = new nockchain_common_v1_pagination_pb.PageResponse;
      reader.readMessage(value,nockchain_common_v1_pagination_pb.PageResponse.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.Balance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.Balance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.Balance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.Balance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNotesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.nockchain.common.v2.BalanceEntry.serializeBinaryToWriter
    );
  }
  f = message.getHeight();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.BlockHeight.serializeBinaryToWriter
    );
  }
  f = message.getBlockId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      nockchain_common_v1_pagination_pb.PageResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BalanceEntry notes = 1;
 * @return {!Array<!proto.nockchain.common.v2.BalanceEntry>}
 */
proto.nockchain.common.v2.Balance.prototype.getNotesList = function() {
  return /** @type{!Array<!proto.nockchain.common.v2.BalanceEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.nockchain.common.v2.BalanceEntry, 1));
};


/**
 * @param {!Array<!proto.nockchain.common.v2.BalanceEntry>} value
 * @return {!proto.nockchain.common.v2.Balance} returns this
*/
proto.nockchain.common.v2.Balance.prototype.setNotesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.nockchain.common.v2.BalanceEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v2.BalanceEntry}
 */
proto.nockchain.common.v2.Balance.prototype.addNotes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.nockchain.common.v2.BalanceEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.common.v2.Balance} returns this
 */
proto.nockchain.common.v2.Balance.prototype.clearNotesList = function() {
  return this.setNotesList([]);
};


/**
 * optional nockchain.common.v1.BlockHeight height = 2;
 * @return {?proto.nockchain.common.v1.BlockHeight}
 */
proto.nockchain.common.v2.Balance.prototype.getHeight = function() {
  return /** @type{?proto.nockchain.common.v1.BlockHeight} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.BlockHeight, 2));
};


/**
 * @param {?proto.nockchain.common.v1.BlockHeight|undefined} value
 * @return {!proto.nockchain.common.v2.Balance} returns this
*/
proto.nockchain.common.v2.Balance.prototype.setHeight = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.Balance} returns this
 */
proto.nockchain.common.v2.Balance.prototype.clearHeight = function() {
  return this.setHeight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.Balance.prototype.hasHeight = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional nockchain.common.v1.Hash block_id = 3;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.common.v2.Balance.prototype.getBlockId = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 3));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.common.v2.Balance} returns this
*/
proto.nockchain.common.v2.Balance.prototype.setBlockId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.Balance} returns this
 */
proto.nockchain.common.v2.Balance.prototype.clearBlockId = function() {
  return this.setBlockId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.Balance.prototype.hasBlockId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional nockchain.common.v1.PageResponse page = 4;
 * @return {?proto.nockchain.common.v1.PageResponse}
 */
proto.nockchain.common.v2.Balance.prototype.getPage = function() {
  return /** @type{?proto.nockchain.common.v1.PageResponse} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_pagination_pb.PageResponse, 4));
};


/**
 * @param {?proto.nockchain.common.v1.PageResponse|undefined} value
 * @return {!proto.nockchain.common.v2.Balance} returns this
*/
proto.nockchain.common.v2.Balance.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.Balance} returns this
 */
proto.nockchain.common.v2.Balance.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.Balance.prototype.hasPage = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.BalanceEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.BalanceEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.BalanceEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.BalanceEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
name: (f = msg.getName()) && nockchain_common_v1_blockchain_pb.Name.toObject(includeInstance, f),
note: (f = msg.getNote()) && proto.nockchain.common.v2.Note.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.BalanceEntry}
 */
proto.nockchain.common.v2.BalanceEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.BalanceEntry;
  return proto.nockchain.common.v2.BalanceEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.BalanceEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.BalanceEntry}
 */
proto.nockchain.common.v2.BalanceEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_blockchain_pb.Name;
      reader.readMessage(value,nockchain_common_v1_blockchain_pb.Name.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v2.Note;
      reader.readMessage(value,proto.nockchain.common.v2.Note.deserializeBinaryFromReader);
      msg.setNote(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.BalanceEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.BalanceEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.BalanceEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.BalanceEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_blockchain_pb.Name.serializeBinaryToWriter
    );
  }
  f = message.getNote();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v2.Note.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.Name name = 1;
 * @return {?proto.nockchain.common.v1.Name}
 */
proto.nockchain.common.v2.BalanceEntry.prototype.getName = function() {
  return /** @type{?proto.nockchain.common.v1.Name} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_blockchain_pb.Name, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Name|undefined} value
 * @return {!proto.nockchain.common.v2.BalanceEntry} returns this
*/
proto.nockchain.common.v2.BalanceEntry.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.BalanceEntry} returns this
 */
proto.nockchain.common.v2.BalanceEntry.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.BalanceEntry.prototype.hasName = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Note note = 2;
 * @return {?proto.nockchain.common.v2.Note}
 */
proto.nockchain.common.v2.BalanceEntry.prototype.getNote = function() {
  return /** @type{?proto.nockchain.common.v2.Note} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v2.Note, 2));
};


/**
 * @param {?proto.nockchain.common.v2.Note|undefined} value
 * @return {!proto.nockchain.common.v2.BalanceEntry} returns this
*/
proto.nockchain.common.v2.BalanceEntry.prototype.setNote = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.BalanceEntry} returns this
 */
proto.nockchain.common.v2.BalanceEntry.prototype.clearNote = function() {
  return this.setNote(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.BalanceEntry.prototype.hasNote = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.nockchain.common.v2.Note.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.nockchain.common.v2.Note.NoteVersionCase = {
  NOTE_VERSION_NOT_SET: 0,
  LEGACY: 1,
  V1: 2
};

/**
 * @return {proto.nockchain.common.v2.Note.NoteVersionCase}
 */
proto.nockchain.common.v2.Note.prototype.getNoteVersionCase = function() {
  return /** @type {proto.nockchain.common.v2.Note.NoteVersionCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.common.v2.Note.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.Note.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.Note.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.Note} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.Note.toObject = function(includeInstance, msg) {
  var f, obj = {
legacy: (f = msg.getLegacy()) && nockchain_common_v1_blockchain_pb.Note.toObject(includeInstance, f),
v1: (f = msg.getV1()) && proto.nockchain.common.v2.NoteV1.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.Note}
 */
proto.nockchain.common.v2.Note.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.Note;
  return proto.nockchain.common.v2.Note.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.Note} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.Note}
 */
proto.nockchain.common.v2.Note.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_blockchain_pb.Note;
      reader.readMessage(value,nockchain_common_v1_blockchain_pb.Note.deserializeBinaryFromReader);
      msg.setLegacy(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v2.NoteV1;
      reader.readMessage(value,proto.nockchain.common.v2.NoteV1.deserializeBinaryFromReader);
      msg.setV1(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.Note.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.Note.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.Note} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.Note.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLegacy();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_blockchain_pb.Note.serializeBinaryToWriter
    );
  }
  f = message.getV1();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v2.NoteV1.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.Note legacy = 1;
 * @return {?proto.nockchain.common.v1.Note}
 */
proto.nockchain.common.v2.Note.prototype.getLegacy = function() {
  return /** @type{?proto.nockchain.common.v1.Note} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_blockchain_pb.Note, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Note|undefined} value
 * @return {!proto.nockchain.common.v2.Note} returns this
*/
proto.nockchain.common.v2.Note.prototype.setLegacy = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.nockchain.common.v2.Note.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.Note} returns this
 */
proto.nockchain.common.v2.Note.prototype.clearLegacy = function() {
  return this.setLegacy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.Note.prototype.hasLegacy = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional NoteV1 v1 = 2;
 * @return {?proto.nockchain.common.v2.NoteV1}
 */
proto.nockchain.common.v2.Note.prototype.getV1 = function() {
  return /** @type{?proto.nockchain.common.v2.NoteV1} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v2.NoteV1, 2));
};


/**
 * @param {?proto.nockchain.common.v2.NoteV1|undefined} value
 * @return {!proto.nockchain.common.v2.Note} returns this
*/
proto.nockchain.common.v2.Note.prototype.setV1 = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.nockchain.common.v2.Note.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.Note} returns this
 */
proto.nockchain.common.v2.Note.prototype.clearV1 = function() {
  return this.setV1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.Note.prototype.hasV1 = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.NoteV1.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.NoteV1.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.NoteV1} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.NoteV1.toObject = function(includeInstance, msg) {
  var f, obj = {
version: (f = msg.getVersion()) && nockchain_common_v1_primitives_pb.NoteVersion.toObject(includeInstance, f),
originPage: (f = msg.getOriginPage()) && nockchain_common_v1_primitives_pb.BlockHeight.toObject(includeInstance, f),
name: (f = msg.getName()) && nockchain_common_v1_blockchain_pb.Name.toObject(includeInstance, f),
noteData: (f = msg.getNoteData()) && proto.nockchain.common.v2.NoteData.toObject(includeInstance, f),
assets: (f = msg.getAssets()) && nockchain_common_v1_primitives_pb.Nicks.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.NoteV1}
 */
proto.nockchain.common.v2.NoteV1.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.NoteV1;
  return proto.nockchain.common.v2.NoteV1.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.NoteV1} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.NoteV1}
 */
proto.nockchain.common.v2.NoteV1.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.NoteVersion;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.NoteVersion.deserializeBinaryFromReader);
      msg.setVersion(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.BlockHeight;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.BlockHeight.deserializeBinaryFromReader);
      msg.setOriginPage(value);
      break;
    case 3:
      var value = new nockchain_common_v1_blockchain_pb.Name;
      reader.readMessage(value,nockchain_common_v1_blockchain_pb.Name.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 4:
      var value = new proto.nockchain.common.v2.NoteData;
      reader.readMessage(value,proto.nockchain.common.v2.NoteData.deserializeBinaryFromReader);
      msg.setNoteData(value);
      break;
    case 5:
      var value = new nockchain_common_v1_primitives_pb.Nicks;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Nicks.deserializeBinaryFromReader);
      msg.setAssets(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.NoteV1.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.NoteV1.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.NoteV1} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.NoteV1.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersion();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.NoteVersion.serializeBinaryToWriter
    );
  }
  f = message.getOriginPage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.BlockHeight.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      nockchain_common_v1_blockchain_pb.Name.serializeBinaryToWriter
    );
  }
  f = message.getNoteData();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.nockchain.common.v2.NoteData.serializeBinaryToWriter
    );
  }
  f = message.getAssets();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      nockchain_common_v1_primitives_pb.Nicks.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.NoteVersion version = 1;
 * @return {?proto.nockchain.common.v1.NoteVersion}
 */
proto.nockchain.common.v2.NoteV1.prototype.getVersion = function() {
  return /** @type{?proto.nockchain.common.v1.NoteVersion} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.NoteVersion, 1));
};


/**
 * @param {?proto.nockchain.common.v1.NoteVersion|undefined} value
 * @return {!proto.nockchain.common.v2.NoteV1} returns this
*/
proto.nockchain.common.v2.NoteV1.prototype.setVersion = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.NoteV1} returns this
 */
proto.nockchain.common.v2.NoteV1.prototype.clearVersion = function() {
  return this.setVersion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.NoteV1.prototype.hasVersion = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional nockchain.common.v1.BlockHeight origin_page = 2;
 * @return {?proto.nockchain.common.v1.BlockHeight}
 */
proto.nockchain.common.v2.NoteV1.prototype.getOriginPage = function() {
  return /** @type{?proto.nockchain.common.v1.BlockHeight} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.BlockHeight, 2));
};


/**
 * @param {?proto.nockchain.common.v1.BlockHeight|undefined} value
 * @return {!proto.nockchain.common.v2.NoteV1} returns this
*/
proto.nockchain.common.v2.NoteV1.prototype.setOriginPage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.NoteV1} returns this
 */
proto.nockchain.common.v2.NoteV1.prototype.clearOriginPage = function() {
  return this.setOriginPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.NoteV1.prototype.hasOriginPage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional nockchain.common.v1.Name name = 3;
 * @return {?proto.nockchain.common.v1.Name}
 */
proto.nockchain.common.v2.NoteV1.prototype.getName = function() {
  return /** @type{?proto.nockchain.common.v1.Name} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_blockchain_pb.Name, 3));
};


/**
 * @param {?proto.nockchain.common.v1.Name|undefined} value
 * @return {!proto.nockchain.common.v2.NoteV1} returns this
*/
proto.nockchain.common.v2.NoteV1.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.NoteV1} returns this
 */
proto.nockchain.common.v2.NoteV1.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.NoteV1.prototype.hasName = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional NoteData note_data = 4;
 * @return {?proto.nockchain.common.v2.NoteData}
 */
proto.nockchain.common.v2.NoteV1.prototype.getNoteData = function() {
  return /** @type{?proto.nockchain.common.v2.NoteData} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v2.NoteData, 4));
};


/**
 * @param {?proto.nockchain.common.v2.NoteData|undefined} value
 * @return {!proto.nockchain.common.v2.NoteV1} returns this
*/
proto.nockchain.common.v2.NoteV1.prototype.setNoteData = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.NoteV1} returns this
 */
proto.nockchain.common.v2.NoteV1.prototype.clearNoteData = function() {
  return this.setNoteData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.NoteV1.prototype.hasNoteData = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional nockchain.common.v1.Nicks assets = 5;
 * @return {?proto.nockchain.common.v1.Nicks}
 */
proto.nockchain.common.v2.NoteV1.prototype.getAssets = function() {
  return /** @type{?proto.nockchain.common.v1.Nicks} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Nicks, 5));
};


/**
 * @param {?proto.nockchain.common.v1.Nicks|undefined} value
 * @return {!proto.nockchain.common.v2.NoteV1} returns this
*/
proto.nockchain.common.v2.NoteV1.prototype.setAssets = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.NoteV1} returns this
 */
proto.nockchain.common.v2.NoteV1.prototype.clearAssets = function() {
  return this.setAssets(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.NoteV1.prototype.hasAssets = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.common.v2.NoteData.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.NoteData.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.NoteData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.NoteData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.NoteData.toObject = function(includeInstance, msg) {
  var f, obj = {
entriesList: jspb.Message.toObjectList(msg.getEntriesList(),
    proto.nockchain.common.v2.NoteDataEntry.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.NoteData}
 */
proto.nockchain.common.v2.NoteData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.NoteData;
  return proto.nockchain.common.v2.NoteData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.NoteData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.NoteData}
 */
proto.nockchain.common.v2.NoteData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v2.NoteDataEntry;
      reader.readMessage(value,proto.nockchain.common.v2.NoteDataEntry.deserializeBinaryFromReader);
      msg.addEntries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.NoteData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.NoteData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.NoteData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.NoteData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.nockchain.common.v2.NoteDataEntry.serializeBinaryToWriter
    );
  }
};


/**
 * repeated NoteDataEntry entries = 1;
 * @return {!Array<!proto.nockchain.common.v2.NoteDataEntry>}
 */
proto.nockchain.common.v2.NoteData.prototype.getEntriesList = function() {
  return /** @type{!Array<!proto.nockchain.common.v2.NoteDataEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.nockchain.common.v2.NoteDataEntry, 1));
};


/**
 * @param {!Array<!proto.nockchain.common.v2.NoteDataEntry>} value
 * @return {!proto.nockchain.common.v2.NoteData} returns this
*/
proto.nockchain.common.v2.NoteData.prototype.setEntriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.nockchain.common.v2.NoteDataEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v2.NoteDataEntry}
 */
proto.nockchain.common.v2.NoteData.prototype.addEntries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.nockchain.common.v2.NoteDataEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.common.v2.NoteData} returns this
 */
proto.nockchain.common.v2.NoteData.prototype.clearEntriesList = function() {
  return this.setEntriesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.NoteDataEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.NoteDataEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.NoteDataEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.NoteDataEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
key: jspb.Message.getFieldWithDefault(msg, 1, ""),
blob: msg.getBlob_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.NoteDataEntry}
 */
proto.nockchain.common.v2.NoteDataEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.NoteDataEntry;
  return proto.nockchain.common.v2.NoteDataEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.NoteDataEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.NoteDataEntry}
 */
proto.nockchain.common.v2.NoteDataEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setBlob(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.NoteDataEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.NoteDataEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.NoteDataEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.NoteDataEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBlob_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.nockchain.common.v2.NoteDataEntry.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.nockchain.common.v2.NoteDataEntry} returns this
 */
proto.nockchain.common.v2.NoteDataEntry.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes blob = 2;
 * @return {!(string|Uint8Array)}
 */
proto.nockchain.common.v2.NoteDataEntry.prototype.getBlob = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes blob = 2;
 * This is a type-conversion wrapper around `getBlob()`
 * @return {string}
 */
proto.nockchain.common.v2.NoteDataEntry.prototype.getBlob_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getBlob()));
};


/**
 * optional bytes blob = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBlob()`
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.NoteDataEntry.prototype.getBlob_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getBlob()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.nockchain.common.v2.NoteDataEntry} returns this
 */
proto.nockchain.common.v2.NoteDataEntry.prototype.setBlob = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.common.v2.RawTransaction.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.RawTransaction.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.RawTransaction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.RawTransaction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.RawTransaction.toObject = function(includeInstance, msg) {
  var f, obj = {
version: (f = msg.getVersion()) && nockchain_common_v1_primitives_pb.NoteVersion.toObject(includeInstance, f),
id: (f = msg.getId()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f),
spendsList: jspb.Message.toObjectList(msg.getSpendsList(),
    proto.nockchain.common.v2.SpendEntry.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.RawTransaction}
 */
proto.nockchain.common.v2.RawTransaction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.RawTransaction;
  return proto.nockchain.common.v2.RawTransaction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.RawTransaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.RawTransaction}
 */
proto.nockchain.common.v2.RawTransaction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.NoteVersion;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.NoteVersion.deserializeBinaryFromReader);
      msg.setVersion(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 3:
      var value = new proto.nockchain.common.v2.SpendEntry;
      reader.readMessage(value,proto.nockchain.common.v2.SpendEntry.deserializeBinaryFromReader);
      msg.addSpends(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.RawTransaction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.RawTransaction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.RawTransaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.RawTransaction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersion();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.NoteVersion.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
  f = message.getSpendsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.nockchain.common.v2.SpendEntry.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.NoteVersion version = 1;
 * @return {?proto.nockchain.common.v1.NoteVersion}
 */
proto.nockchain.common.v2.RawTransaction.prototype.getVersion = function() {
  return /** @type{?proto.nockchain.common.v1.NoteVersion} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.NoteVersion, 1));
};


/**
 * @param {?proto.nockchain.common.v1.NoteVersion|undefined} value
 * @return {!proto.nockchain.common.v2.RawTransaction} returns this
*/
proto.nockchain.common.v2.RawTransaction.prototype.setVersion = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.RawTransaction} returns this
 */
proto.nockchain.common.v2.RawTransaction.prototype.clearVersion = function() {
  return this.setVersion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.RawTransaction.prototype.hasVersion = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional nockchain.common.v1.Hash id = 2;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.common.v2.RawTransaction.prototype.getId = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 2));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.common.v2.RawTransaction} returns this
*/
proto.nockchain.common.v2.RawTransaction.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.RawTransaction} returns this
 */
proto.nockchain.common.v2.RawTransaction.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.RawTransaction.prototype.hasId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated SpendEntry spends = 3;
 * @return {!Array<!proto.nockchain.common.v2.SpendEntry>}
 */
proto.nockchain.common.v2.RawTransaction.prototype.getSpendsList = function() {
  return /** @type{!Array<!proto.nockchain.common.v2.SpendEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.nockchain.common.v2.SpendEntry, 3));
};


/**
 * @param {!Array<!proto.nockchain.common.v2.SpendEntry>} value
 * @return {!proto.nockchain.common.v2.RawTransaction} returns this
*/
proto.nockchain.common.v2.RawTransaction.prototype.setSpendsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.nockchain.common.v2.SpendEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v2.SpendEntry}
 */
proto.nockchain.common.v2.RawTransaction.prototype.addSpends = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.nockchain.common.v2.SpendEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.common.v2.RawTransaction} returns this
 */
proto.nockchain.common.v2.RawTransaction.prototype.clearSpendsList = function() {
  return this.setSpendsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.SpendEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.SpendEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.SpendEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.SpendEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
name: (f = msg.getName()) && nockchain_common_v1_blockchain_pb.Name.toObject(includeInstance, f),
spend: (f = msg.getSpend()) && proto.nockchain.common.v2.Spend.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.SpendEntry}
 */
proto.nockchain.common.v2.SpendEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.SpendEntry;
  return proto.nockchain.common.v2.SpendEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.SpendEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.SpendEntry}
 */
proto.nockchain.common.v2.SpendEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_blockchain_pb.Name;
      reader.readMessage(value,nockchain_common_v1_blockchain_pb.Name.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v2.Spend;
      reader.readMessage(value,proto.nockchain.common.v2.Spend.deserializeBinaryFromReader);
      msg.setSpend(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.SpendEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.SpendEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.SpendEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.SpendEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_blockchain_pb.Name.serializeBinaryToWriter
    );
  }
  f = message.getSpend();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v2.Spend.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.Name name = 1;
 * @return {?proto.nockchain.common.v1.Name}
 */
proto.nockchain.common.v2.SpendEntry.prototype.getName = function() {
  return /** @type{?proto.nockchain.common.v1.Name} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_blockchain_pb.Name, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Name|undefined} value
 * @return {!proto.nockchain.common.v2.SpendEntry} returns this
*/
proto.nockchain.common.v2.SpendEntry.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.SpendEntry} returns this
 */
proto.nockchain.common.v2.SpendEntry.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.SpendEntry.prototype.hasName = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Spend spend = 2;
 * @return {?proto.nockchain.common.v2.Spend}
 */
proto.nockchain.common.v2.SpendEntry.prototype.getSpend = function() {
  return /** @type{?proto.nockchain.common.v2.Spend} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v2.Spend, 2));
};


/**
 * @param {?proto.nockchain.common.v2.Spend|undefined} value
 * @return {!proto.nockchain.common.v2.SpendEntry} returns this
*/
proto.nockchain.common.v2.SpendEntry.prototype.setSpend = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.SpendEntry} returns this
 */
proto.nockchain.common.v2.SpendEntry.prototype.clearSpend = function() {
  return this.setSpend(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.SpendEntry.prototype.hasSpend = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.nockchain.common.v2.Spend.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.nockchain.common.v2.Spend.SpendKindCase = {
  SPEND_KIND_NOT_SET: 0,
  LEGACY: 1,
  WITNESS: 2
};

/**
 * @return {proto.nockchain.common.v2.Spend.SpendKindCase}
 */
proto.nockchain.common.v2.Spend.prototype.getSpendKindCase = function() {
  return /** @type {proto.nockchain.common.v2.Spend.SpendKindCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.common.v2.Spend.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.Spend.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.Spend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.Spend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.Spend.toObject = function(includeInstance, msg) {
  var f, obj = {
legacy: (f = msg.getLegacy()) && proto.nockchain.common.v2.LegacySpend.toObject(includeInstance, f),
witness: (f = msg.getWitness()) && proto.nockchain.common.v2.WitnessSpend.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.Spend}
 */
proto.nockchain.common.v2.Spend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.Spend;
  return proto.nockchain.common.v2.Spend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.Spend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.Spend}
 */
proto.nockchain.common.v2.Spend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v2.LegacySpend;
      reader.readMessage(value,proto.nockchain.common.v2.LegacySpend.deserializeBinaryFromReader);
      msg.setLegacy(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v2.WitnessSpend;
      reader.readMessage(value,proto.nockchain.common.v2.WitnessSpend.deserializeBinaryFromReader);
      msg.setWitness(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.Spend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.Spend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.Spend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.Spend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLegacy();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.common.v2.LegacySpend.serializeBinaryToWriter
    );
  }
  f = message.getWitness();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v2.WitnessSpend.serializeBinaryToWriter
    );
  }
};


/**
 * optional LegacySpend legacy = 1;
 * @return {?proto.nockchain.common.v2.LegacySpend}
 */
proto.nockchain.common.v2.Spend.prototype.getLegacy = function() {
  return /** @type{?proto.nockchain.common.v2.LegacySpend} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v2.LegacySpend, 1));
};


/**
 * @param {?proto.nockchain.common.v2.LegacySpend|undefined} value
 * @return {!proto.nockchain.common.v2.Spend} returns this
*/
proto.nockchain.common.v2.Spend.prototype.setLegacy = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.nockchain.common.v2.Spend.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.Spend} returns this
 */
proto.nockchain.common.v2.Spend.prototype.clearLegacy = function() {
  return this.setLegacy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.Spend.prototype.hasLegacy = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional WitnessSpend witness = 2;
 * @return {?proto.nockchain.common.v2.WitnessSpend}
 */
proto.nockchain.common.v2.Spend.prototype.getWitness = function() {
  return /** @type{?proto.nockchain.common.v2.WitnessSpend} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v2.WitnessSpend, 2));
};


/**
 * @param {?proto.nockchain.common.v2.WitnessSpend|undefined} value
 * @return {!proto.nockchain.common.v2.Spend} returns this
*/
proto.nockchain.common.v2.Spend.prototype.setWitness = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.nockchain.common.v2.Spend.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.Spend} returns this
 */
proto.nockchain.common.v2.Spend.prototype.clearWitness = function() {
  return this.setWitness(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.Spend.prototype.hasWitness = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.common.v2.LegacySpend.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.LegacySpend.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.LegacySpend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.LegacySpend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.LegacySpend.toObject = function(includeInstance, msg) {
  var f, obj = {
signature: (f = msg.getSignature()) && nockchain_common_v1_blockchain_pb.Signature.toObject(includeInstance, f),
seedsList: jspb.Message.toObjectList(msg.getSeedsList(),
    proto.nockchain.common.v2.Seed.toObject, includeInstance),
fee: (f = msg.getFee()) && nockchain_common_v1_primitives_pb.Nicks.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.LegacySpend}
 */
proto.nockchain.common.v2.LegacySpend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.LegacySpend;
  return proto.nockchain.common.v2.LegacySpend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.LegacySpend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.LegacySpend}
 */
proto.nockchain.common.v2.LegacySpend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_blockchain_pb.Signature;
      reader.readMessage(value,nockchain_common_v1_blockchain_pb.Signature.deserializeBinaryFromReader);
      msg.setSignature(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v2.Seed;
      reader.readMessage(value,proto.nockchain.common.v2.Seed.deserializeBinaryFromReader);
      msg.addSeeds(value);
      break;
    case 3:
      var value = new nockchain_common_v1_primitives_pb.Nicks;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Nicks.deserializeBinaryFromReader);
      msg.setFee(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.LegacySpend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.LegacySpend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.LegacySpend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.LegacySpend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSignature();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_blockchain_pb.Signature.serializeBinaryToWriter
    );
  }
  f = message.getSeedsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.nockchain.common.v2.Seed.serializeBinaryToWriter
    );
  }
  f = message.getFee();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      nockchain_common_v1_primitives_pb.Nicks.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.Signature signature = 1;
 * @return {?proto.nockchain.common.v1.Signature}
 */
proto.nockchain.common.v2.LegacySpend.prototype.getSignature = function() {
  return /** @type{?proto.nockchain.common.v1.Signature} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_blockchain_pb.Signature, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Signature|undefined} value
 * @return {!proto.nockchain.common.v2.LegacySpend} returns this
*/
proto.nockchain.common.v2.LegacySpend.prototype.setSignature = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.LegacySpend} returns this
 */
proto.nockchain.common.v2.LegacySpend.prototype.clearSignature = function() {
  return this.setSignature(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.LegacySpend.prototype.hasSignature = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Seed seeds = 2;
 * @return {!Array<!proto.nockchain.common.v2.Seed>}
 */
proto.nockchain.common.v2.LegacySpend.prototype.getSeedsList = function() {
  return /** @type{!Array<!proto.nockchain.common.v2.Seed>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.nockchain.common.v2.Seed, 2));
};


/**
 * @param {!Array<!proto.nockchain.common.v2.Seed>} value
 * @return {!proto.nockchain.common.v2.LegacySpend} returns this
*/
proto.nockchain.common.v2.LegacySpend.prototype.setSeedsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.nockchain.common.v2.Seed=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v2.Seed}
 */
proto.nockchain.common.v2.LegacySpend.prototype.addSeeds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.nockchain.common.v2.Seed, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.common.v2.LegacySpend} returns this
 */
proto.nockchain.common.v2.LegacySpend.prototype.clearSeedsList = function() {
  return this.setSeedsList([]);
};


/**
 * optional nockchain.common.v1.Nicks fee = 3;
 * @return {?proto.nockchain.common.v1.Nicks}
 */
proto.nockchain.common.v2.LegacySpend.prototype.getFee = function() {
  return /** @type{?proto.nockchain.common.v1.Nicks} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Nicks, 3));
};


/**
 * @param {?proto.nockchain.common.v1.Nicks|undefined} value
 * @return {!proto.nockchain.common.v2.LegacySpend} returns this
*/
proto.nockchain.common.v2.LegacySpend.prototype.setFee = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.LegacySpend} returns this
 */
proto.nockchain.common.v2.LegacySpend.prototype.clearFee = function() {
  return this.setFee(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.LegacySpend.prototype.hasFee = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.common.v2.WitnessSpend.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.WitnessSpend.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.WitnessSpend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.WitnessSpend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.WitnessSpend.toObject = function(includeInstance, msg) {
  var f, obj = {
witness: (f = msg.getWitness()) && proto.nockchain.common.v2.Witness.toObject(includeInstance, f),
seedsList: jspb.Message.toObjectList(msg.getSeedsList(),
    proto.nockchain.common.v2.Seed.toObject, includeInstance),
fee: (f = msg.getFee()) && nockchain_common_v1_primitives_pb.Nicks.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.WitnessSpend}
 */
proto.nockchain.common.v2.WitnessSpend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.WitnessSpend;
  return proto.nockchain.common.v2.WitnessSpend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.WitnessSpend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.WitnessSpend}
 */
proto.nockchain.common.v2.WitnessSpend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v2.Witness;
      reader.readMessage(value,proto.nockchain.common.v2.Witness.deserializeBinaryFromReader);
      msg.setWitness(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v2.Seed;
      reader.readMessage(value,proto.nockchain.common.v2.Seed.deserializeBinaryFromReader);
      msg.addSeeds(value);
      break;
    case 3:
      var value = new nockchain_common_v1_primitives_pb.Nicks;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Nicks.deserializeBinaryFromReader);
      msg.setFee(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.WitnessSpend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.WitnessSpend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.WitnessSpend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.WitnessSpend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWitness();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.common.v2.Witness.serializeBinaryToWriter
    );
  }
  f = message.getSeedsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.nockchain.common.v2.Seed.serializeBinaryToWriter
    );
  }
  f = message.getFee();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      nockchain_common_v1_primitives_pb.Nicks.serializeBinaryToWriter
    );
  }
};


/**
 * optional Witness witness = 1;
 * @return {?proto.nockchain.common.v2.Witness}
 */
proto.nockchain.common.v2.WitnessSpend.prototype.getWitness = function() {
  return /** @type{?proto.nockchain.common.v2.Witness} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v2.Witness, 1));
};


/**
 * @param {?proto.nockchain.common.v2.Witness|undefined} value
 * @return {!proto.nockchain.common.v2.WitnessSpend} returns this
*/
proto.nockchain.common.v2.WitnessSpend.prototype.setWitness = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.WitnessSpend} returns this
 */
proto.nockchain.common.v2.WitnessSpend.prototype.clearWitness = function() {
  return this.setWitness(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.WitnessSpend.prototype.hasWitness = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Seed seeds = 2;
 * @return {!Array<!proto.nockchain.common.v2.Seed>}
 */
proto.nockchain.common.v2.WitnessSpend.prototype.getSeedsList = function() {
  return /** @type{!Array<!proto.nockchain.common.v2.Seed>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.nockchain.common.v2.Seed, 2));
};


/**
 * @param {!Array<!proto.nockchain.common.v2.Seed>} value
 * @return {!proto.nockchain.common.v2.WitnessSpend} returns this
*/
proto.nockchain.common.v2.WitnessSpend.prototype.setSeedsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.nockchain.common.v2.Seed=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v2.Seed}
 */
proto.nockchain.common.v2.WitnessSpend.prototype.addSeeds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.nockchain.common.v2.Seed, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.common.v2.WitnessSpend} returns this
 */
proto.nockchain.common.v2.WitnessSpend.prototype.clearSeedsList = function() {
  return this.setSeedsList([]);
};


/**
 * optional nockchain.common.v1.Nicks fee = 3;
 * @return {?proto.nockchain.common.v1.Nicks}
 */
proto.nockchain.common.v2.WitnessSpend.prototype.getFee = function() {
  return /** @type{?proto.nockchain.common.v1.Nicks} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Nicks, 3));
};


/**
 * @param {?proto.nockchain.common.v1.Nicks|undefined} value
 * @return {!proto.nockchain.common.v2.WitnessSpend} returns this
*/
proto.nockchain.common.v2.WitnessSpend.prototype.setFee = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.WitnessSpend} returns this
 */
proto.nockchain.common.v2.WitnessSpend.prototype.clearFee = function() {
  return this.setFee(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.WitnessSpend.prototype.hasFee = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.Seed.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.Seed.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.Seed} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.Seed.toObject = function(includeInstance, msg) {
  var f, obj = {
outputSource: (f = msg.getOutputSource()) && nockchain_common_v1_blockchain_pb.Source.toObject(includeInstance, f),
lockRoot: (f = msg.getLockRoot()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f),
noteData: (f = msg.getNoteData()) && proto.nockchain.common.v2.NoteData.toObject(includeInstance, f),
gift: (f = msg.getGift()) && nockchain_common_v1_primitives_pb.Nicks.toObject(includeInstance, f),
parentHash: (f = msg.getParentHash()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.Seed}
 */
proto.nockchain.common.v2.Seed.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.Seed;
  return proto.nockchain.common.v2.Seed.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.Seed} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.Seed}
 */
proto.nockchain.common.v2.Seed.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_blockchain_pb.Source;
      reader.readMessage(value,nockchain_common_v1_blockchain_pb.Source.deserializeBinaryFromReader);
      msg.setOutputSource(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setLockRoot(value);
      break;
    case 3:
      var value = new proto.nockchain.common.v2.NoteData;
      reader.readMessage(value,proto.nockchain.common.v2.NoteData.deserializeBinaryFromReader);
      msg.setNoteData(value);
      break;
    case 4:
      var value = new nockchain_common_v1_primitives_pb.Nicks;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Nicks.deserializeBinaryFromReader);
      msg.setGift(value);
      break;
    case 5:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setParentHash(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.Seed.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.Seed.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.Seed} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.Seed.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOutputSource();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_blockchain_pb.Source.serializeBinaryToWriter
    );
  }
  f = message.getLockRoot();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
  f = message.getNoteData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.nockchain.common.v2.NoteData.serializeBinaryToWriter
    );
  }
  f = message.getGift();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      nockchain_common_v1_primitives_pb.Nicks.serializeBinaryToWriter
    );
  }
  f = message.getParentHash();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.Source output_source = 1;
 * @return {?proto.nockchain.common.v1.Source}
 */
proto.nockchain.common.v2.Seed.prototype.getOutputSource = function() {
  return /** @type{?proto.nockchain.common.v1.Source} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_blockchain_pb.Source, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Source|undefined} value
 * @return {!proto.nockchain.common.v2.Seed} returns this
*/
proto.nockchain.common.v2.Seed.prototype.setOutputSource = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.Seed} returns this
 */
proto.nockchain.common.v2.Seed.prototype.clearOutputSource = function() {
  return this.setOutputSource(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.Seed.prototype.hasOutputSource = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional nockchain.common.v1.Hash lock_root = 2;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.common.v2.Seed.prototype.getLockRoot = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 2));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.common.v2.Seed} returns this
*/
proto.nockchain.common.v2.Seed.prototype.setLockRoot = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.Seed} returns this
 */
proto.nockchain.common.v2.Seed.prototype.clearLockRoot = function() {
  return this.setLockRoot(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.Seed.prototype.hasLockRoot = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional NoteData note_data = 3;
 * @return {?proto.nockchain.common.v2.NoteData}
 */
proto.nockchain.common.v2.Seed.prototype.getNoteData = function() {
  return /** @type{?proto.nockchain.common.v2.NoteData} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v2.NoteData, 3));
};


/**
 * @param {?proto.nockchain.common.v2.NoteData|undefined} value
 * @return {!proto.nockchain.common.v2.Seed} returns this
*/
proto.nockchain.common.v2.Seed.prototype.setNoteData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.Seed} returns this
 */
proto.nockchain.common.v2.Seed.prototype.clearNoteData = function() {
  return this.setNoteData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.Seed.prototype.hasNoteData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional nockchain.common.v1.Nicks gift = 4;
 * @return {?proto.nockchain.common.v1.Nicks}
 */
proto.nockchain.common.v2.Seed.prototype.getGift = function() {
  return /** @type{?proto.nockchain.common.v1.Nicks} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Nicks, 4));
};


/**
 * @param {?proto.nockchain.common.v1.Nicks|undefined} value
 * @return {!proto.nockchain.common.v2.Seed} returns this
*/
proto.nockchain.common.v2.Seed.prototype.setGift = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.Seed} returns this
 */
proto.nockchain.common.v2.Seed.prototype.clearGift = function() {
  return this.setGift(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.Seed.prototype.hasGift = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional nockchain.common.v1.Hash parent_hash = 5;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.common.v2.Seed.prototype.getParentHash = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 5));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.common.v2.Seed} returns this
*/
proto.nockchain.common.v2.Seed.prototype.setParentHash = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.Seed} returns this
 */
proto.nockchain.common.v2.Seed.prototype.clearParentHash = function() {
  return this.setParentHash(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.Seed.prototype.hasParentHash = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.common.v2.Witness.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.Witness.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.Witness.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.Witness} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.Witness.toObject = function(includeInstance, msg) {
  var f, obj = {
lockMerkleProof: (f = msg.getLockMerkleProof()) && proto.nockchain.common.v2.LockMerkleProof.toObject(includeInstance, f),
pkhSignature: (f = msg.getPkhSignature()) && proto.nockchain.common.v2.PkhSignature.toObject(includeInstance, f),
haxList: jspb.Message.toObjectList(msg.getHaxList(),
    proto.nockchain.common.v2.HaxPreimage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.Witness}
 */
proto.nockchain.common.v2.Witness.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.Witness;
  return proto.nockchain.common.v2.Witness.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.Witness} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.Witness}
 */
proto.nockchain.common.v2.Witness.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v2.LockMerkleProof;
      reader.readMessage(value,proto.nockchain.common.v2.LockMerkleProof.deserializeBinaryFromReader);
      msg.setLockMerkleProof(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v2.PkhSignature;
      reader.readMessage(value,proto.nockchain.common.v2.PkhSignature.deserializeBinaryFromReader);
      msg.setPkhSignature(value);
      break;
    case 3:
      var value = new proto.nockchain.common.v2.HaxPreimage;
      reader.readMessage(value,proto.nockchain.common.v2.HaxPreimage.deserializeBinaryFromReader);
      msg.addHax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.Witness.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.Witness.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.Witness} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.Witness.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLockMerkleProof();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.common.v2.LockMerkleProof.serializeBinaryToWriter
    );
  }
  f = message.getPkhSignature();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v2.PkhSignature.serializeBinaryToWriter
    );
  }
  f = message.getHaxList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.nockchain.common.v2.HaxPreimage.serializeBinaryToWriter
    );
  }
};


/**
 * optional LockMerkleProof lock_merkle_proof = 1;
 * @return {?proto.nockchain.common.v2.LockMerkleProof}
 */
proto.nockchain.common.v2.Witness.prototype.getLockMerkleProof = function() {
  return /** @type{?proto.nockchain.common.v2.LockMerkleProof} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v2.LockMerkleProof, 1));
};


/**
 * @param {?proto.nockchain.common.v2.LockMerkleProof|undefined} value
 * @return {!proto.nockchain.common.v2.Witness} returns this
*/
proto.nockchain.common.v2.Witness.prototype.setLockMerkleProof = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.Witness} returns this
 */
proto.nockchain.common.v2.Witness.prototype.clearLockMerkleProof = function() {
  return this.setLockMerkleProof(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.Witness.prototype.hasLockMerkleProof = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PkhSignature pkh_signature = 2;
 * @return {?proto.nockchain.common.v2.PkhSignature}
 */
proto.nockchain.common.v2.Witness.prototype.getPkhSignature = function() {
  return /** @type{?proto.nockchain.common.v2.PkhSignature} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v2.PkhSignature, 2));
};


/**
 * @param {?proto.nockchain.common.v2.PkhSignature|undefined} value
 * @return {!proto.nockchain.common.v2.Witness} returns this
*/
proto.nockchain.common.v2.Witness.prototype.setPkhSignature = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.Witness} returns this
 */
proto.nockchain.common.v2.Witness.prototype.clearPkhSignature = function() {
  return this.setPkhSignature(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.Witness.prototype.hasPkhSignature = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated HaxPreimage hax = 3;
 * @return {!Array<!proto.nockchain.common.v2.HaxPreimage>}
 */
proto.nockchain.common.v2.Witness.prototype.getHaxList = function() {
  return /** @type{!Array<!proto.nockchain.common.v2.HaxPreimage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.nockchain.common.v2.HaxPreimage, 3));
};


/**
 * @param {!Array<!proto.nockchain.common.v2.HaxPreimage>} value
 * @return {!proto.nockchain.common.v2.Witness} returns this
*/
proto.nockchain.common.v2.Witness.prototype.setHaxList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.nockchain.common.v2.HaxPreimage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v2.HaxPreimage}
 */
proto.nockchain.common.v2.Witness.prototype.addHax = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.nockchain.common.v2.HaxPreimage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.common.v2.Witness} returns this
 */
proto.nockchain.common.v2.Witness.prototype.clearHaxList = function() {
  return this.setHaxList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.HaxPreimage.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.HaxPreimage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.HaxPreimage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.HaxPreimage.toObject = function(includeInstance, msg) {
  var f, obj = {
hash: (f = msg.getHash()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f),
value: msg.getValue_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.HaxPreimage}
 */
proto.nockchain.common.v2.HaxPreimage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.HaxPreimage;
  return proto.nockchain.common.v2.HaxPreimage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.HaxPreimage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.HaxPreimage}
 */
proto.nockchain.common.v2.HaxPreimage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setHash(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.HaxPreimage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.HaxPreimage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.HaxPreimage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.HaxPreimage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHash();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
  f = message.getValue_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional nockchain.common.v1.Hash hash = 1;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.common.v2.HaxPreimage.prototype.getHash = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.common.v2.HaxPreimage} returns this
*/
proto.nockchain.common.v2.HaxPreimage.prototype.setHash = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.HaxPreimage} returns this
 */
proto.nockchain.common.v2.HaxPreimage.prototype.clearHash = function() {
  return this.setHash(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.HaxPreimage.prototype.hasHash = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes value = 2;
 * @return {!(string|Uint8Array)}
 */
proto.nockchain.common.v2.HaxPreimage.prototype.getValue = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes value = 2;
 * This is a type-conversion wrapper around `getValue()`
 * @return {string}
 */
proto.nockchain.common.v2.HaxPreimage.prototype.getValue_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getValue()));
};


/**
 * optional bytes value = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValue()`
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.HaxPreimage.prototype.getValue_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getValue()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.nockchain.common.v2.HaxPreimage} returns this
 */
proto.nockchain.common.v2.HaxPreimage.prototype.setValue = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.common.v2.PkhSignature.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.PkhSignature.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.PkhSignature.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.PkhSignature} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.PkhSignature.toObject = function(includeInstance, msg) {
  var f, obj = {
entriesList: jspb.Message.toObjectList(msg.getEntriesList(),
    proto.nockchain.common.v2.PkhSignatureEntry.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.PkhSignature}
 */
proto.nockchain.common.v2.PkhSignature.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.PkhSignature;
  return proto.nockchain.common.v2.PkhSignature.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.PkhSignature} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.PkhSignature}
 */
proto.nockchain.common.v2.PkhSignature.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v2.PkhSignatureEntry;
      reader.readMessage(value,proto.nockchain.common.v2.PkhSignatureEntry.deserializeBinaryFromReader);
      msg.addEntries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.PkhSignature.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.PkhSignature.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.PkhSignature} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.PkhSignature.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.nockchain.common.v2.PkhSignatureEntry.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PkhSignatureEntry entries = 1;
 * @return {!Array<!proto.nockchain.common.v2.PkhSignatureEntry>}
 */
proto.nockchain.common.v2.PkhSignature.prototype.getEntriesList = function() {
  return /** @type{!Array<!proto.nockchain.common.v2.PkhSignatureEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.nockchain.common.v2.PkhSignatureEntry, 1));
};


/**
 * @param {!Array<!proto.nockchain.common.v2.PkhSignatureEntry>} value
 * @return {!proto.nockchain.common.v2.PkhSignature} returns this
*/
proto.nockchain.common.v2.PkhSignature.prototype.setEntriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.nockchain.common.v2.PkhSignatureEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v2.PkhSignatureEntry}
 */
proto.nockchain.common.v2.PkhSignature.prototype.addEntries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.nockchain.common.v2.PkhSignatureEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.common.v2.PkhSignature} returns this
 */
proto.nockchain.common.v2.PkhSignature.prototype.clearEntriesList = function() {
  return this.setEntriesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.PkhSignatureEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.PkhSignatureEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.PkhSignatureEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.PkhSignatureEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
hash: (f = msg.getHash()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f),
pubkey: (f = msg.getPubkey()) && nockchain_common_v1_primitives_pb.SchnorrPubkey.toObject(includeInstance, f),
signature: (f = msg.getSignature()) && nockchain_common_v1_blockchain_pb.SchnorrSignature.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.PkhSignatureEntry}
 */
proto.nockchain.common.v2.PkhSignatureEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.PkhSignatureEntry;
  return proto.nockchain.common.v2.PkhSignatureEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.PkhSignatureEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.PkhSignatureEntry}
 */
proto.nockchain.common.v2.PkhSignatureEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setHash(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.SchnorrPubkey;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.SchnorrPubkey.deserializeBinaryFromReader);
      msg.setPubkey(value);
      break;
    case 3:
      var value = new nockchain_common_v1_blockchain_pb.SchnorrSignature;
      reader.readMessage(value,nockchain_common_v1_blockchain_pb.SchnorrSignature.deserializeBinaryFromReader);
      msg.setSignature(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.PkhSignatureEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.PkhSignatureEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.PkhSignatureEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.PkhSignatureEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHash();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
  f = message.getPubkey();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.SchnorrPubkey.serializeBinaryToWriter
    );
  }
  f = message.getSignature();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      nockchain_common_v1_blockchain_pb.SchnorrSignature.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.Hash hash = 1;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.common.v2.PkhSignatureEntry.prototype.getHash = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.common.v2.PkhSignatureEntry} returns this
*/
proto.nockchain.common.v2.PkhSignatureEntry.prototype.setHash = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.PkhSignatureEntry} returns this
 */
proto.nockchain.common.v2.PkhSignatureEntry.prototype.clearHash = function() {
  return this.setHash(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.PkhSignatureEntry.prototype.hasHash = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional nockchain.common.v1.SchnorrPubkey pubkey = 2;
 * @return {?proto.nockchain.common.v1.SchnorrPubkey}
 */
proto.nockchain.common.v2.PkhSignatureEntry.prototype.getPubkey = function() {
  return /** @type{?proto.nockchain.common.v1.SchnorrPubkey} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.SchnorrPubkey, 2));
};


/**
 * @param {?proto.nockchain.common.v1.SchnorrPubkey|undefined} value
 * @return {!proto.nockchain.common.v2.PkhSignatureEntry} returns this
*/
proto.nockchain.common.v2.PkhSignatureEntry.prototype.setPubkey = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.PkhSignatureEntry} returns this
 */
proto.nockchain.common.v2.PkhSignatureEntry.prototype.clearPubkey = function() {
  return this.setPubkey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.PkhSignatureEntry.prototype.hasPubkey = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional nockchain.common.v1.SchnorrSignature signature = 3;
 * @return {?proto.nockchain.common.v1.SchnorrSignature}
 */
proto.nockchain.common.v2.PkhSignatureEntry.prototype.getSignature = function() {
  return /** @type{?proto.nockchain.common.v1.SchnorrSignature} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_blockchain_pb.SchnorrSignature, 3));
};


/**
 * @param {?proto.nockchain.common.v1.SchnorrSignature|undefined} value
 * @return {!proto.nockchain.common.v2.PkhSignatureEntry} returns this
*/
proto.nockchain.common.v2.PkhSignatureEntry.prototype.setSignature = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.PkhSignatureEntry} returns this
 */
proto.nockchain.common.v2.PkhSignatureEntry.prototype.clearSignature = function() {
  return this.setSignature(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.PkhSignatureEntry.prototype.hasSignature = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.LockMerkleProof.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.LockMerkleProof.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.LockMerkleProof} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.LockMerkleProof.toObject = function(includeInstance, msg) {
  var f, obj = {
spendCondition: (f = msg.getSpendCondition()) && proto.nockchain.common.v2.SpendCondition.toObject(includeInstance, f),
axis: jspb.Message.getFieldWithDefault(msg, 2, 0),
proof: (f = msg.getProof()) && proto.nockchain.common.v2.MerkleProof.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.LockMerkleProof}
 */
proto.nockchain.common.v2.LockMerkleProof.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.LockMerkleProof;
  return proto.nockchain.common.v2.LockMerkleProof.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.LockMerkleProof} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.LockMerkleProof}
 */
proto.nockchain.common.v2.LockMerkleProof.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v2.SpendCondition;
      reader.readMessage(value,proto.nockchain.common.v2.SpendCondition.deserializeBinaryFromReader);
      msg.setSpendCondition(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAxis(value);
      break;
    case 3:
      var value = new proto.nockchain.common.v2.MerkleProof;
      reader.readMessage(value,proto.nockchain.common.v2.MerkleProof.deserializeBinaryFromReader);
      msg.setProof(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.LockMerkleProof.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.LockMerkleProof.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.LockMerkleProof} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.LockMerkleProof.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSpendCondition();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.common.v2.SpendCondition.serializeBinaryToWriter
    );
  }
  f = message.getAxis();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getProof();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.nockchain.common.v2.MerkleProof.serializeBinaryToWriter
    );
  }
};


/**
 * optional SpendCondition spend_condition = 1;
 * @return {?proto.nockchain.common.v2.SpendCondition}
 */
proto.nockchain.common.v2.LockMerkleProof.prototype.getSpendCondition = function() {
  return /** @type{?proto.nockchain.common.v2.SpendCondition} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v2.SpendCondition, 1));
};


/**
 * @param {?proto.nockchain.common.v2.SpendCondition|undefined} value
 * @return {!proto.nockchain.common.v2.LockMerkleProof} returns this
*/
proto.nockchain.common.v2.LockMerkleProof.prototype.setSpendCondition = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.LockMerkleProof} returns this
 */
proto.nockchain.common.v2.LockMerkleProof.prototype.clearSpendCondition = function() {
  return this.setSpendCondition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.LockMerkleProof.prototype.hasSpendCondition = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint64 axis = 2;
 * @return {number}
 */
proto.nockchain.common.v2.LockMerkleProof.prototype.getAxis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.common.v2.LockMerkleProof} returns this
 */
proto.nockchain.common.v2.LockMerkleProof.prototype.setAxis = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional MerkleProof proof = 3;
 * @return {?proto.nockchain.common.v2.MerkleProof}
 */
proto.nockchain.common.v2.LockMerkleProof.prototype.getProof = function() {
  return /** @type{?proto.nockchain.common.v2.MerkleProof} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v2.MerkleProof, 3));
};


/**
 * @param {?proto.nockchain.common.v2.MerkleProof|undefined} value
 * @return {!proto.nockchain.common.v2.LockMerkleProof} returns this
*/
proto.nockchain.common.v2.LockMerkleProof.prototype.setProof = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.LockMerkleProof} returns this
 */
proto.nockchain.common.v2.LockMerkleProof.prototype.clearProof = function() {
  return this.setProof(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.LockMerkleProof.prototype.hasProof = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.common.v2.SpendCondition.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.SpendCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.SpendCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.SpendCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.SpendCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
primitivesList: jspb.Message.toObjectList(msg.getPrimitivesList(),
    proto.nockchain.common.v2.LockPrimitive.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.SpendCondition}
 */
proto.nockchain.common.v2.SpendCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.SpendCondition;
  return proto.nockchain.common.v2.SpendCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.SpendCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.SpendCondition}
 */
proto.nockchain.common.v2.SpendCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v2.LockPrimitive;
      reader.readMessage(value,proto.nockchain.common.v2.LockPrimitive.deserializeBinaryFromReader);
      msg.addPrimitives(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.SpendCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.SpendCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.SpendCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.SpendCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrimitivesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.nockchain.common.v2.LockPrimitive.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LockPrimitive primitives = 1;
 * @return {!Array<!proto.nockchain.common.v2.LockPrimitive>}
 */
proto.nockchain.common.v2.SpendCondition.prototype.getPrimitivesList = function() {
  return /** @type{!Array<!proto.nockchain.common.v2.LockPrimitive>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.nockchain.common.v2.LockPrimitive, 1));
};


/**
 * @param {!Array<!proto.nockchain.common.v2.LockPrimitive>} value
 * @return {!proto.nockchain.common.v2.SpendCondition} returns this
*/
proto.nockchain.common.v2.SpendCondition.prototype.setPrimitivesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.nockchain.common.v2.LockPrimitive=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v2.LockPrimitive}
 */
proto.nockchain.common.v2.SpendCondition.prototype.addPrimitives = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.nockchain.common.v2.LockPrimitive, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.common.v2.SpendCondition} returns this
 */
proto.nockchain.common.v2.SpendCondition.prototype.clearPrimitivesList = function() {
  return this.setPrimitivesList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.nockchain.common.v2.LockPrimitive.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.nockchain.common.v2.LockPrimitive.PrimitiveCase = {
  PRIMITIVE_NOT_SET: 0,
  PKH: 1,
  TIM: 2,
  HAX: 3,
  BURN: 4
};

/**
 * @return {proto.nockchain.common.v2.LockPrimitive.PrimitiveCase}
 */
proto.nockchain.common.v2.LockPrimitive.prototype.getPrimitiveCase = function() {
  return /** @type {proto.nockchain.common.v2.LockPrimitive.PrimitiveCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.common.v2.LockPrimitive.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.LockPrimitive.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.LockPrimitive.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.LockPrimitive} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.LockPrimitive.toObject = function(includeInstance, msg) {
  var f, obj = {
pkh: (f = msg.getPkh()) && proto.nockchain.common.v2.PkhLock.toObject(includeInstance, f),
tim: (f = msg.getTim()) && proto.nockchain.common.v2.LockTim.toObject(includeInstance, f),
hax: (f = msg.getHax()) && proto.nockchain.common.v2.HaxLock.toObject(includeInstance, f),
burn: (f = msg.getBurn()) && proto.nockchain.common.v2.BurnLock.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.LockPrimitive}
 */
proto.nockchain.common.v2.LockPrimitive.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.LockPrimitive;
  return proto.nockchain.common.v2.LockPrimitive.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.LockPrimitive} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.LockPrimitive}
 */
proto.nockchain.common.v2.LockPrimitive.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v2.PkhLock;
      reader.readMessage(value,proto.nockchain.common.v2.PkhLock.deserializeBinaryFromReader);
      msg.setPkh(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v2.LockTim;
      reader.readMessage(value,proto.nockchain.common.v2.LockTim.deserializeBinaryFromReader);
      msg.setTim(value);
      break;
    case 3:
      var value = new proto.nockchain.common.v2.HaxLock;
      reader.readMessage(value,proto.nockchain.common.v2.HaxLock.deserializeBinaryFromReader);
      msg.setHax(value);
      break;
    case 4:
      var value = new proto.nockchain.common.v2.BurnLock;
      reader.readMessage(value,proto.nockchain.common.v2.BurnLock.deserializeBinaryFromReader);
      msg.setBurn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.LockPrimitive.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.LockPrimitive.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.LockPrimitive} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.LockPrimitive.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPkh();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.common.v2.PkhLock.serializeBinaryToWriter
    );
  }
  f = message.getTim();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v2.LockTim.serializeBinaryToWriter
    );
  }
  f = message.getHax();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.nockchain.common.v2.HaxLock.serializeBinaryToWriter
    );
  }
  f = message.getBurn();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.nockchain.common.v2.BurnLock.serializeBinaryToWriter
    );
  }
};


/**
 * optional PkhLock pkh = 1;
 * @return {?proto.nockchain.common.v2.PkhLock}
 */
proto.nockchain.common.v2.LockPrimitive.prototype.getPkh = function() {
  return /** @type{?proto.nockchain.common.v2.PkhLock} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v2.PkhLock, 1));
};


/**
 * @param {?proto.nockchain.common.v2.PkhLock|undefined} value
 * @return {!proto.nockchain.common.v2.LockPrimitive} returns this
*/
proto.nockchain.common.v2.LockPrimitive.prototype.setPkh = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.nockchain.common.v2.LockPrimitive.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.LockPrimitive} returns this
 */
proto.nockchain.common.v2.LockPrimitive.prototype.clearPkh = function() {
  return this.setPkh(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.LockPrimitive.prototype.hasPkh = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LockTim tim = 2;
 * @return {?proto.nockchain.common.v2.LockTim}
 */
proto.nockchain.common.v2.LockPrimitive.prototype.getTim = function() {
  return /** @type{?proto.nockchain.common.v2.LockTim} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v2.LockTim, 2));
};


/**
 * @param {?proto.nockchain.common.v2.LockTim|undefined} value
 * @return {!proto.nockchain.common.v2.LockPrimitive} returns this
*/
proto.nockchain.common.v2.LockPrimitive.prototype.setTim = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.nockchain.common.v2.LockPrimitive.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.LockPrimitive} returns this
 */
proto.nockchain.common.v2.LockPrimitive.prototype.clearTim = function() {
  return this.setTim(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.LockPrimitive.prototype.hasTim = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional HaxLock hax = 3;
 * @return {?proto.nockchain.common.v2.HaxLock}
 */
proto.nockchain.common.v2.LockPrimitive.prototype.getHax = function() {
  return /** @type{?proto.nockchain.common.v2.HaxLock} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v2.HaxLock, 3));
};


/**
 * @param {?proto.nockchain.common.v2.HaxLock|undefined} value
 * @return {!proto.nockchain.common.v2.LockPrimitive} returns this
*/
proto.nockchain.common.v2.LockPrimitive.prototype.setHax = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.nockchain.common.v2.LockPrimitive.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.LockPrimitive} returns this
 */
proto.nockchain.common.v2.LockPrimitive.prototype.clearHax = function() {
  return this.setHax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.LockPrimitive.prototype.hasHax = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional BurnLock burn = 4;
 * @return {?proto.nockchain.common.v2.BurnLock}
 */
proto.nockchain.common.v2.LockPrimitive.prototype.getBurn = function() {
  return /** @type{?proto.nockchain.common.v2.BurnLock} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v2.BurnLock, 4));
};


/**
 * @param {?proto.nockchain.common.v2.BurnLock|undefined} value
 * @return {!proto.nockchain.common.v2.LockPrimitive} returns this
*/
proto.nockchain.common.v2.LockPrimitive.prototype.setBurn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.nockchain.common.v2.LockPrimitive.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.LockPrimitive} returns this
 */
proto.nockchain.common.v2.LockPrimitive.prototype.clearBurn = function() {
  return this.setBurn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.LockPrimitive.prototype.hasBurn = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.common.v2.PkhLock.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.PkhLock.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.PkhLock.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.PkhLock} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.PkhLock.toObject = function(includeInstance, msg) {
  var f, obj = {
m: jspb.Message.getFieldWithDefault(msg, 1, 0),
hashesList: jspb.Message.toObjectList(msg.getHashesList(),
    nockchain_common_v1_primitives_pb.Hash.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.PkhLock}
 */
proto.nockchain.common.v2.PkhLock.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.PkhLock;
  return proto.nockchain.common.v2.PkhLock.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.PkhLock} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.PkhLock}
 */
proto.nockchain.common.v2.PkhLock.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setM(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.addHashes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.PkhLock.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.PkhLock.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.PkhLock} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.PkhLock.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getM();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getHashesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 m = 1;
 * @return {number}
 */
proto.nockchain.common.v2.PkhLock.prototype.getM = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.common.v2.PkhLock} returns this
 */
proto.nockchain.common.v2.PkhLock.prototype.setM = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated nockchain.common.v1.Hash hashes = 2;
 * @return {!Array<!proto.nockchain.common.v1.Hash>}
 */
proto.nockchain.common.v2.PkhLock.prototype.getHashesList = function() {
  return /** @type{!Array<!proto.nockchain.common.v1.Hash>} */ (
    jspb.Message.getRepeatedWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 2));
};


/**
 * @param {!Array<!proto.nockchain.common.v1.Hash>} value
 * @return {!proto.nockchain.common.v2.PkhLock} returns this
*/
proto.nockchain.common.v2.PkhLock.prototype.setHashesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.nockchain.common.v1.Hash=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v1.Hash}
 */
proto.nockchain.common.v2.PkhLock.prototype.addHashes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.nockchain.common.v1.Hash, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.common.v2.PkhLock} returns this
 */
proto.nockchain.common.v2.PkhLock.prototype.clearHashesList = function() {
  return this.setHashesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.LockTim.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.LockTim.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.LockTim} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.LockTim.toObject = function(includeInstance, msg) {
  var f, obj = {
rel: (f = msg.getRel()) && nockchain_common_v1_blockchain_pb.TimeLockRangeRelative.toObject(includeInstance, f),
abs: (f = msg.getAbs()) && nockchain_common_v1_blockchain_pb.TimeLockRangeAbsolute.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.LockTim}
 */
proto.nockchain.common.v2.LockTim.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.LockTim;
  return proto.nockchain.common.v2.LockTim.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.LockTim} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.LockTim}
 */
proto.nockchain.common.v2.LockTim.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_blockchain_pb.TimeLockRangeRelative;
      reader.readMessage(value,nockchain_common_v1_blockchain_pb.TimeLockRangeRelative.deserializeBinaryFromReader);
      msg.setRel(value);
      break;
    case 2:
      var value = new nockchain_common_v1_blockchain_pb.TimeLockRangeAbsolute;
      reader.readMessage(value,nockchain_common_v1_blockchain_pb.TimeLockRangeAbsolute.deserializeBinaryFromReader);
      msg.setAbs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.LockTim.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.LockTim.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.LockTim} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.LockTim.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRel();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_blockchain_pb.TimeLockRangeRelative.serializeBinaryToWriter
    );
  }
  f = message.getAbs();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_blockchain_pb.TimeLockRangeAbsolute.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.TimeLockRangeRelative rel = 1;
 * @return {?proto.nockchain.common.v1.TimeLockRangeRelative}
 */
proto.nockchain.common.v2.LockTim.prototype.getRel = function() {
  return /** @type{?proto.nockchain.common.v1.TimeLockRangeRelative} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_blockchain_pb.TimeLockRangeRelative, 1));
};


/**
 * @param {?proto.nockchain.common.v1.TimeLockRangeRelative|undefined} value
 * @return {!proto.nockchain.common.v2.LockTim} returns this
*/
proto.nockchain.common.v2.LockTim.prototype.setRel = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.LockTim} returns this
 */
proto.nockchain.common.v2.LockTim.prototype.clearRel = function() {
  return this.setRel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.LockTim.prototype.hasRel = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional nockchain.common.v1.TimeLockRangeAbsolute abs = 2;
 * @return {?proto.nockchain.common.v1.TimeLockRangeAbsolute}
 */
proto.nockchain.common.v2.LockTim.prototype.getAbs = function() {
  return /** @type{?proto.nockchain.common.v1.TimeLockRangeAbsolute} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_blockchain_pb.TimeLockRangeAbsolute, 2));
};


/**
 * @param {?proto.nockchain.common.v1.TimeLockRangeAbsolute|undefined} value
 * @return {!proto.nockchain.common.v2.LockTim} returns this
*/
proto.nockchain.common.v2.LockTim.prototype.setAbs = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.LockTim} returns this
 */
proto.nockchain.common.v2.LockTim.prototype.clearAbs = function() {
  return this.setAbs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.LockTim.prototype.hasAbs = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.common.v2.HaxLock.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.HaxLock.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.HaxLock.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.HaxLock} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.HaxLock.toObject = function(includeInstance, msg) {
  var f, obj = {
hashesList: jspb.Message.toObjectList(msg.getHashesList(),
    nockchain_common_v1_primitives_pb.Hash.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.HaxLock}
 */
proto.nockchain.common.v2.HaxLock.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.HaxLock;
  return proto.nockchain.common.v2.HaxLock.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.HaxLock} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.HaxLock}
 */
proto.nockchain.common.v2.HaxLock.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.addHashes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.HaxLock.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.HaxLock.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.HaxLock} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.HaxLock.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHashesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
};


/**
 * repeated nockchain.common.v1.Hash hashes = 1;
 * @return {!Array<!proto.nockchain.common.v1.Hash>}
 */
proto.nockchain.common.v2.HaxLock.prototype.getHashesList = function() {
  return /** @type{!Array<!proto.nockchain.common.v1.Hash>} */ (
    jspb.Message.getRepeatedWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 1));
};


/**
 * @param {!Array<!proto.nockchain.common.v1.Hash>} value
 * @return {!proto.nockchain.common.v2.HaxLock} returns this
*/
proto.nockchain.common.v2.HaxLock.prototype.setHashesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.nockchain.common.v1.Hash=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v1.Hash}
 */
proto.nockchain.common.v2.HaxLock.prototype.addHashes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.nockchain.common.v1.Hash, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.common.v2.HaxLock} returns this
 */
proto.nockchain.common.v2.HaxLock.prototype.clearHashesList = function() {
  return this.setHashesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.BurnLock.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.BurnLock.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.BurnLock} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.BurnLock.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.BurnLock}
 */
proto.nockchain.common.v2.BurnLock.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.BurnLock;
  return proto.nockchain.common.v2.BurnLock.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.BurnLock} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.BurnLock}
 */
proto.nockchain.common.v2.BurnLock.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.BurnLock.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.BurnLock.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.BurnLock} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.BurnLock.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.common.v2.MerkleProof.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v2.MerkleProof.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v2.MerkleProof.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v2.MerkleProof} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.MerkleProof.toObject = function(includeInstance, msg) {
  var f, obj = {
root: (f = msg.getRoot()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f),
pathList: jspb.Message.toObjectList(msg.getPathList(),
    nockchain_common_v1_primitives_pb.Hash.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v2.MerkleProof}
 */
proto.nockchain.common.v2.MerkleProof.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v2.MerkleProof;
  return proto.nockchain.common.v2.MerkleProof.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v2.MerkleProof} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v2.MerkleProof}
 */
proto.nockchain.common.v2.MerkleProof.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setRoot(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.addPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v2.MerkleProof.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v2.MerkleProof.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v2.MerkleProof} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v2.MerkleProof.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoot();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
  f = message.getPathList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
};


/**
 * optional nockchain.common.v1.Hash root = 1;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.common.v2.MerkleProof.prototype.getRoot = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.common.v2.MerkleProof} returns this
*/
proto.nockchain.common.v2.MerkleProof.prototype.setRoot = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v2.MerkleProof} returns this
 */
proto.nockchain.common.v2.MerkleProof.prototype.clearRoot = function() {
  return this.setRoot(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v2.MerkleProof.prototype.hasRoot = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated nockchain.common.v1.Hash path = 2;
 * @return {!Array<!proto.nockchain.common.v1.Hash>}
 */
proto.nockchain.common.v2.MerkleProof.prototype.getPathList = function() {
  return /** @type{!Array<!proto.nockchain.common.v1.Hash>} */ (
    jspb.Message.getRepeatedWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 2));
};


/**
 * @param {!Array<!proto.nockchain.common.v1.Hash>} value
 * @return {!proto.nockchain.common.v2.MerkleProof} returns this
*/
proto.nockchain.common.v2.MerkleProof.prototype.setPathList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.nockchain.common.v1.Hash=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v1.Hash}
 */
proto.nockchain.common.v2.MerkleProof.prototype.addPath = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.nockchain.common.v1.Hash, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.common.v2.MerkleProof} returns this
 */
proto.nockchain.common.v2.MerkleProof.prototype.clearPathList = function() {
  return this.setPathList([]);
};


goog.object.extend(exports, proto.nockchain.common.v2);
